import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
	mainMenuList: [],
	subMenuList: [],
};

// active account slice
export const mainMenuSlice = createSlice({
	name: 'mainMenu',
	initialState,
	reducers: {
		setMainMenuList: (state, action) => {
			state.mainMenuList = action.payload;
		},
		setSubMenuList: (state, action) => {
			state.subMenuList = action.payload;
		},
	},
});

export const { setMainMenuList, setSubMenuList } = mainMenuSlice.actions;

export default mainMenuSlice.reducer;
